import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/fit';
import Summary from '../ModalThemeSummary';
import CommentsSubmitAllButton from '../CommentsSubmitAllButton';
import reportToBigQuery from '../../../Utils/bigQueryReporter';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { CLICKED_WARNING_MODAL } from '../../../Utils/mixpanel/mixpanelEvents';
import * as CommentsActions from '../../actions/comments';
import * as CommentsSelectors from '../../selectors/comments';
import * as Selectors from '../../selectors';
import * as Translations from '../../providers/i18n';

import './style.scss';

class PromptPendingComments extends React.Component {
    componentDidMount = () => {
        this.reportShowPendingPromptEvent();
    }

    reportContinueEditingEvent = () => {
        reportToBigQuery({
            group: 'collaboration',
            type: 'clicked_on_warning_message',
            reason: 'continue editing',
            collaboration: {
                pending_comments: this.props.pendingCommentsIdsLength
            }
        });

        sendMixPanelEvent({
            eventName: CLICKED_WARNING_MODAL,
            eventData: {
                'Source Button': 'Continue editing'
            }
        });
    }

    reportClearPendingEvent = () => {
        reportToBigQuery({
            group: 'collaboration',
            type: 'clicked_on_warning_message',
            reason: 'leave without sending comments',
            collaboration: {
                pending_comments: this.props.pendingCommentsIdsLength
            }
        });

        sendMixPanelEvent({
            eventName: CLICKED_WARNING_MODAL,
            eventData: {
                'Source Button': 'no thanks'
            }
        });
    }

    reportShowPendingPromptEvent = () => {
        reportToBigQuery({
            group: 'collaboration',
            type: 'seen_warning_comments_not_save',
            collaboration: {
                pending_comments: this.props.pendingCommentsIdsLength
            }
        });
    }

    onCloseClick = () => {
        this.reportContinueEditingEvent();
        this.props.setShouldOpen(false);
    }

    onDiscard = () => {
        const {
            pendingCommentsIds,
            deleteComment,
            callback,
            setShouldOpen
        } = this.props;

        callback();

        setShouldOpen(false);

        this.reportClearPendingEvent();

        pendingCommentsIds.forEach((id) => deleteComment(id));
    }

    render() {
        const {
            callback,
            shouldNotShowSubmitButton,
            setShouldOpen,
            shouldOpen,
            i18n
        } = this.props;

        if (!shouldOpen) {
            return null;
        }

        return (
            <Summary name="pending-comments-prompt-modal attachments_preview-package order_page_perseus"
                autoOpen={true}
                onClickCloseButton={this.onCloseClick}
                header={i18n.t('attachments_preview.collaboration.leave_prompt.header')}
                className="pending-comments-prompt-modal-wrapper"
                footer={() => (
                    <div className="btns-container">
                        <Button className="discard-button" color="light-grey" onClick={this.onDiscard}>
                            {i18n.t('attachments_preview.collaboration.leave_prompt.discard_comments')}
                        </Button>
                        {shouldNotShowSubmitButton
                            ? <Button onClick={() => setShouldOpen(false)}>
                                {i18n.t('attachments_preview.collaboration.leave_prompt.continue')}
                            </Button>
                            : <CommentsSubmitAllButton onSubmit={callback} onClick={() => setShouldOpen(false)}/>
                        }
                    </div>
                )}>
                {() => (
                    <div className="pending-content">
                        <p>
                            {i18n.t('attachments_preview.collaboration.leave_prompt.body')}
                        </p>
                    </div>
                )}
            </Summary>
        );
    }
}

PromptPendingComments.propTypes = {
    pendingCommentsIds: PropTypes.array,
    pendingCommentsIdsLength: PropTypes.number,
    deleteComment: PropTypes.func,
    callback: PropTypes.func,
    shouldNotShowSubmitButton: PropTypes.bool,
    setShouldOpen: PropTypes.func,
    shouldOpen: PropTypes.bool,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

PromptPendingComments.defaultProps = {
    pendingCommentsIds: [],
    pendingCommentsIdsLength: 0,
    deleteComment: () => null,
    callback: () => null,
    shouldNotShowSubmitButton: false
};

const mapStateToProps = (state) => {
    const pendingCommentsIds = CommentsSelectors.getPendingIds(state);
    return ({
        pendingCommentsIds,
        pendingCommentsIdsLength: pendingCommentsIds.length,
        shouldNotShowSubmitButton: Selectors.isSellerGroupInRevisionMode(state)
    });
};

export default compose(
    Translations.connect,
    connect(mapStateToProps, {
        deleteComment: CommentsActions.deleteComment
    }))(PromptPendingComments);
